import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { type TransportationModeFiltersUpdateApi, transportationModesApiSchema } from '../../models';

const masterDataApi = fetcher.extend(() => ({ prefixUrl: `${API.MASTER_DATA_PUBLIC}` }));

export const fetchTransportationModes = async (
  filters: TransportationModeFiltersUpdateApi,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await masterDataApi
      .get('lookup-code/QUTEMODE', { searchParams: filters, signal })
      .json(transportationModesApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn(
        'Validation error on transportation modes response',
        (error as ValiError<typeof transportationModesApiSchema>).issues,
      );
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
